import { Label, Input, FormGroup } from 'reactstrap'
import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

class Checkboxes extends React.Component {
    render() {
        // const { t } = this.props
        return (
            <FormGroup check>
                <div className="pt-1">
                    {
                        this.props.options.map((option) => (
                            <div>
                                {
                                    this.props.questionMultichoice ?
                                        <Label check className="checkbox-label" key={option.id}>
                                            <Input type="checkbox" className="mt-0 md-font-size" name={`question_${this.props.questionId}`} value={`${this.props.questionId}_${option.id}`} />{' '}
                                            {option.title}
                                        </Label>
                                        :
                                        <Label check className="checkbox-label" key={option.id}>
                                            <Input type="radio" className="mt-0 md-font-size" name={`question_${this.props.questionId}`} value={`${this.props.questionId}_${option.id}`} />{' '}
                                            {option.title}
                                        </Label>
                                }
                            </div>
                        ))
                    }
                </div>
            </FormGroup>
        )
    }
}

Checkboxes.propTypes = {
    t: PropTypes.func,
    options: PropTypes.array,
    questionId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
}

export default withTranslation()(Checkboxes)



// WEBPACK FOOTER //
// ./src/components/Study/Checkboxes.jsx